import columns from '../../../../react-table/helpers/columns';

export default (data) => {
  const {
    DateColumn,
    TextColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new DateColumn('Leading Count Start Date', 'startDate'),
        new DateColumn('Leading Count End Date', 'endDate'),
        new TextColumn('Leading Count Type', 'type'),
      ],
    },
  ];
};
